import React from "react";
import styles from "./Career.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import { Link } from "react-router-dom";
// import SliderTo from "../../Components/SliderTo/SliderTo";
import Section from "../../Components/SliderTo/Section";
import CareerStories from "../../Components/Stroies/CareerStories";

const Career = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />
        <Container>
          <Row>
            <Col md={6}>
              <div className={styles.hero_section}>
                <Heading color="#fff">Join the CrossBorder BTC Family</Heading>
                <Paragraph color="#fff">
                  At CrossBorder BTC, we believe our people are our greatest
                  asset. We’re on a mission to redefine global trade, and we’re
                  looking for passionate, talented individuals to join us in
                  shaping the future.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <div className={styles.another_section}>
          <Heading>Why Work with Us?</Heading>
          <Paragraph>
            At CrossBorder BTC, you’ll find more than just a job—you’ll find a{" "}
            <br />
            purpose. We’re committed to creating an environment where you can{" "}
            <br />
            thrive, grow, and make a global impact.
          </Paragraph>

          {/* <SliderTo /> */}
          <CareerStories />
        </div>
      </Container>

    
      <Container>
        <div className={styles.position_section}>
          <Heading>Open Positions</Heading>
          <Paragraph>
            Explore opportunities to take your career to the next level.
          </Paragraph>

          <div className={styles.box}>
            <p> Sales Manager – Global Trade</p>
            <Link to={"#"}>Details</Link>
          </div>
          <div className={styles.box}>
            <p>Sustainability Project Manager</p>
            <Link to={"#"}>Details</Link>
          </div>
          <div className={styles.box}>
            <p> UIUX Designer</p>
            <Link to={"#"}>Details</Link>
          </div>
          <div className={styles.box}>
            <p>Full Stack Developer</p>
            <Link to={"#"}>Details</Link>
          </div>
        </div>
      </Container>

      <Section />

    </React.Fragment>
  );
};

export default Career;
